import React from 'react';
import { BottomSheet } from './BottomSheet';
import { DurationChips } from './DurationChips';
import { DURATION_PRESETS, MODE_LABELS } from '../data/presets';
import { Mode } from '../types/pomodoro';
interface DurationSheetProps {
  open: boolean;
  mode: Mode;
  value: number;
  onClose: () => void;
  onSelect: (minutes: number) => void;
}
export function DurationSheet({
  open,
  mode,
  value,
  onClose,
  onSelect
}: DurationSheetProps) {
  return <BottomSheet open={open} title={`${MODE_LABELS[mode]} duration`} onClose={onClose} data-id="element-42" data-mp="23g9iko4vqe6b">
      <DurationChips presets={DURATION_PRESETS[mode]} value={value} onSelect={onSelect} idPrefix={`sheet-${mode}`} data-id="element-43" data-mp="27kpp8rmbhpml" />
      <p className="mt-4 text-xs leading-relaxed text-muted" data-id="element-44" data-mp="1yi846gief316">
        Your choice is remembered for {MODE_LABELS[mode].toLowerCase()} sessions.
      </p>
    </BottomSheet>;
}